import { DashoardResponse } from "../../types/dashboardResponse";
import { apiClient } from "../../utils/apiClient";


export const fetchDashboard = (role: string) : Promise<DashoardResponse> => {
    return apiClient.get(`/dashboard/getDashboard/${role}`).then((response) => response.data);
}